import { Radio as MuiRadio, RadioProps } from "@mui/material";
import { forwardRef } from "react";

const Radio = forwardRef<HTMLButtonElement, RadioProps>((props, ref) => {
  return <MuiRadio ref={ref} {...props} />;
});

Radio.displayName = "Radio";

export default Radio;
